var vipdelay = 900;

// Ticket Meter
var GAmeterDance = function() {

    var $ga_meter, $bg, $counter, $notice, $accent, $ticks, percent, timeout, $accent, allow_glow;
    $ga_meter = $('div.ga-meter');
    $accent = $ga_meter.find('.accent');
    $ticks = $ga_meter.find('.ticksup');
    $bg = $ga_meter.find('.bar');
    $counter = $ga_meter.find('.bar .p .count');
    $notice = $('.ga-meter .mtitle>.anim');
    percent = $bg.data('percent');
    allow_glow = true;

    $ga_meter.fadeTo(300,.1);
    $ticks.fadeTo(300,.1);
    //$accent.css({'width': '1%'});

    setTimeout(function() {
        $ga_meter.fadeTo(1200,1);
    }, 300);

    setTimeout(function() {
        $notice.animate({'top': 0}, 1850, 'easeInOutExpo');
    }, 500);

    setTimeout(function() {
        $ticks.fadeTo(300,1);
    }, 200);

    setTimeout(function() {
        $accent.animate({'width': '100%'}, 2150, 'easeInOutExpo');
        $bg.animate({'width': percent + "%"}, 2150, 'easeInOutExpo') ;
    }, 500);

    setTimeout(function() {
        //$ga_meter.find('.ga .barbg>div').addClass('redPulse');
        $ga_meter.find('.allowglow').addClass('redShadow');
        //$ga_meter.find('.ga .accent>div').addClass('redPulse');
    }, 2000);

    setTimeout(function() {
        $counter.countTo({
            from: 0,
            to: percent,
            speed: 1450,
            refreshInterval: 10
        });
    }, 1200);
}


// Ticket Meter
var VIPmeterDance = function() {
    var $vip_meter, $bg, $counter, $notice, $accent, $ticks, percent, timeout, $accent, allow_glow;
    $vip_meter = $('div.vip-meter');
    $accent = $vip_meter.find('.accent');
    $ticks = $vip_meter.find('.ticksup');
    $bg = $vip_meter.find('.bar');
    $counter = $vip_meter.find('.bar .p .count');
    $notice = $('.vip-meter .mtitle>.anim');
    percent = $bg.data('percent');
    allow_glow = true;

    $vip_meter.fadeTo(300,.1);
    $ticks.fadeTo(300,.1);
    //$accent.css({'width': '1%'});

    setTimeout(function() {
        $vip_meter.fadeTo(1200,1);
    }, 300);

    setTimeout(function() {
        $notice.animate({'top': 0}, 1850, 'easeInOutExpo');
    }, 500);

    setTimeout(function() {
        $ticks.fadeTo(300,1);
    }, 200);

    setTimeout(function() {
        $accent.animate({'width': '100%'}, 2150, 'easeInOutExpo');
        $bg.animate({'width': percent + "%"}, 2150, 'easeInOutExpo') ;
    }, 500);

    setTimeout(function() {
        //$vip_meter.find('.ga .barbg>div').addClass('redPulse');
        $vip_meter.find('.allowglow').addClass('redShadow');
        //$vip_meter.find('.ga .accent>div').addClass('redPulse');
    }, 2000);

    setTimeout(function() {
        $counter.countTo({
            from: 0,
            to: percent,
            speed: 1450,
            refreshInterval: 10
        });
    }, 1200);
}
